import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBagIcon, SparklesIcon, HeartIcon, TruckIcon, GiftIcon, StarIcon } from '@heroicons/react/24/outline';

const CategoryShowcase = ({ categories }) => {

  // Aktif kategorileri filtrele
  const activeCategories = categories.filter(cat => cat.is_active !== false);

  // Kategori ikonları
  const defaultIcons = [
    ShoppingBagIcon,
    SparklesIcon,
    HeartIcon,
    TruckIcon,
    GiftIcon,
    StarIcon
  ];

  // Gradient renkleri
  const gradients = [
    'from-pink-500 to-rose-500',
    'from-purple-500 to-indigo-500',
    'from-blue-500 to-cyan-500',
    'from-green-500 to-emerald-500',
    'from-yellow-500 to-orange-500',
    'from-red-500 to-pink-500'
  ];

  // Early return check
  if (!activeCategories || activeCategories.length === 0) {
    return null;
  }

  return (
    <div className="w-full bg-gradient-to-b from-white to-gray-50 py-12 my-8 overflow-hidden">
      {/* Başlık - Container içinde */}
      <div className="max-w-7xl mx-auto px-4 mb-8">
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Kategoriler
          </h2>
          <p className="text-gray-600 text-sm sm:text-base mt-1">
            Aradığınız her şey bir tık uzağınızda
          </p>
        </div>
      </div>

      {/* Full-Width Infinite Scroll Container */}
      <div className="relative w-full">
        {/* Gradient fade edges - Full height */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />
          
        <div className="marquee-container">
          <div className="marquee-content">
              {/* İlk set */}
            {/* Triple the categories for seamless loop */}
            {[...activeCategories, ...activeCategories, ...activeCategories].map((category, index) => {
                const IconComponent = defaultIcons[index % defaultIcons.length];
                const gradient = gradients[index % gradients.length];
                
                return (
                  <Link
                    key={`${category.id}-${index}`}
                    to={`/categories/${category.slug}`}
                    className="group inline-block w-44 sm:w-52 bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden transform hover:scale-105 mx-2"
                  >
                    <div className="p-4 sm:p-6 flex flex-col items-center text-center">
                      <div className={`w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-gradient-to-br ${gradient} mb-3 transform group-hover:rotate-6 transition-transform duration-300 overflow-hidden flex items-center justify-center`}>
                        {category.image_url ? (
                          <img 
                            src={category.image_url} 
                            alt={category.name}
                            className="w-full h-full object-cover scale-110"
                          />
                        ) : category.icon ? (
                          <img 
                            src={category.icon} 
                            alt={category.name}
                            className="w-3/4 h-3/4 object-contain"
                          />
                        ) : (
                          <IconComponent className="w-3/4 h-3/4 text-white" />
                        )}
                      </div>
                      <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-1 line-clamp-2">
                        {category.name}
                      </h3>
                      {category.product_count !== undefined && (
                        <p className="text-xs text-gray-500">
                          {category.product_count} ürün
                        </p>
                      )}
                    </div>
                    <div className={`h-1 bg-gradient-to-r ${gradient} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`} />
                  </Link>
                );
              })}
          </div>
        </div>
      </div>

      <style jsx>{`
        .marquee-container {
          overflow: hidden;
          position: relative;
        }
        
        .marquee-content {
          display: flex;
          animation: marquee 30s linear infinite;
          width: fit-content;
        }
        
        .marquee-content:hover {
          animation-play-state: paused;
        }
        
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
      `}</style>
    </div>
  );
};

export default CategoryShowcase;
